import { useState, useEffect } from 'react';
import { Select } from 'antd';
import { parsePhoneNumber } from 'libphonenumber-js';
import styles from '../NodeCustomization.module.css';
import type { CustomizationComponent } from '@/pages/Logiblocks/types';
import useToken from '@/common/helper/useToken';
import {
  GetCompanyPhoneNumbers,
  type CompanyPhoneNumberOption,
} from '@/apis/settings';
import '@/pages/Settings/AiAgents/AgentsTable.css';
import 'react-phone-input-2/lib/style.css';

function phoneOptionLabel(
  phoneNumber: string,
  label: string | null
): React.ReactNode {
  let flagClass = 'us';
  let display = phoneNumber;
  try {
    const parsed = parsePhoneNumber(phoneNumber);
    flagClass = (parsed.country ?? 'US').toLowerCase();
    display = `+${parsed.countryCallingCode} ${parsed.formatNational()}`;
  } catch {
    // fall through to raw number
  }
  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <span
        className='react-tel-input'
        style={{ width: 'auto', flexShrink: 0, lineHeight: 0 }}
      >
        <span
          className={`flag ${flagClass}`}
          style={{ display: 'inline-block' }}
        />
      </span>
      <span>{label ? `${display} (${label})` : display}</span>
    </span>
  );
}

export const InboundCallTriggerCustomization: CustomizationComponent = ({
  nodeData,
  onChange,
  isReadOnly = false,
}) => {
  const { getToken } = useToken();
  const token = getToken();
  const phoneNumber = nodeData.inbound_call_trigger?.phone_number ?? '';
  const [options, setOptions] = useState<CompanyPhoneNumberOption[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) return;
    setLoading(true);
    GetCompanyPhoneNumbers(token, 'InboundTrigger')
      .then((res) => {
        setOptions(res?.data?.data?.data ?? []);
      })
      .catch(() => {
        setOptions([]);
      })
      .finally(() => setLoading(false));
  }, [token]);

  return (
    <div className={styles.customizationSection}>
      <label className={styles.sectionLabel}>Phone Number</label>
      <Select
        className='agentSelect agentSelect--darkText'
        value={phoneNumber || undefined}
        loading={loading}
        disabled={isReadOnly}
        placeholder='Select an inbound number'
        notFoundContent='No inbound numbers available'
        options={options.map((n) => ({
          value: n.phone_number,
          label: phoneOptionLabel(n.phone_number, n.label),
        }))}
        onChange={(value: string) =>
          onChange({ inbound_call_trigger: { phone_number: value } })
        }
      />
    </div>
  );
};
